import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SaveSearchItem } from "src/app/shared/dto";
import { ResultTabsetUrlsEnum } from '../../../../../enums';

@Component({
    selector: 'app-saved-searches-card',
    templateUrl: './saved-searches-card.component.html',
    styleUrls: ['../../../common-reporting-dashboard.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class SavedSearchesCardComponent {
    @Input() isLoading: boolean;
    @Input() savedSearchesData: SaveSearchItem[] = [];

    @Output() recentSavedSearchEvent: EventEmitter<any> = new EventEmitter();

    readonly resultTabsetUrlsEnum: typeof ResultTabsetUrlsEnum = ResultTabsetUrlsEnum;

    onRecentSavedSerch(savedSearchData) {
        this.recentSavedSearchEvent.emit(savedSearchData);
    }
}
